import { generateRoutes } from 'utils/generateRoutes';

export const mfaLoginRoutes = generateRoutes({}, 'mfa-login');
